export default __webpack_public_path__ + "static/media/icn-plus.53fe1e51.svg";